(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-featured-category-grid-assets"] && !Shopify.designMode) return;
  try {
    class BlogCategoryFeaturedSection extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-gtm-init')) return;
    this.setAttribute('data-gtm-init', 'true');

    this.pills = this.querySelectorAll('[data-tab-trigger]');
    this.panels = this.querySelectorAll('[data-tab-panel]');
    if (!this.panels.length) return;

    for (const pill of this.pills) {
      pill.addEventListener('click', () => {
        const filter = pill.getAttribute('data-filter');
        if (!filter) return;
        const category = pill.textContent.replace(/\s+/g, ' ').trim();
        this.#pushDataLayerEvent('click', {
          source: 'blog',
          category,
          page_location: window.location.href
        });
        this.#showTab(filter);
        this.#rememberActiveCategoryTab((pill.getAttribute('data-blog-handle') || '').trim());
        this.#syncCategoryQuery(pill);
      });
    }

    for (const button of this.querySelectorAll('[data-view-more]')) {
      button.addEventListener('click', () => this.#revealMoreArticles(button));
    }

    this.#initArticleLinkTracking();

    if (!this.pills.length) return;

    const initialTab = this.#getInitialTab();
    if (initialTab) this.#showTab(initialTab);

    this.#rememberActiveCategoryTab();
    this.#initCategoryQueryHistory();
    this.#initScrollTracking();
  }

  #getInitialTab() {
    if (this.dataset.variant === 'all-blogs') {
      const categoryHandle = new URLSearchParams(window.location.search).get('category');
      if (categoryHandle) {
        for (const pill of this.pills) {
          if (pill.getAttribute('data-blog-handle') === categoryHandle) {
            return pill.getAttribute('data-filter');
          }
        }
      }
    }

    return (
      this.querySelector('[data-tab-trigger].is-active')?.getAttribute('data-filter') ||
      this.panels[0]?.getAttribute('data-tab')
    );
  }

  #getCategoryHandleForPanel(panel) {
    if (!panel) return '';
    const tabKey = panel.getAttribute('data-tab');
    if (!tabKey) return '';
    const pill = this.querySelector(`[data-tab-trigger][data-filter="${tabKey}"]`);
    return (pill?.getAttribute('data-blog-handle') || '').trim();
  }

  #rememberActiveCategoryTab(blogHandle) {
    let handle = blogHandle;
    if (handle === undefined) {
      const activePill = this.querySelector('[data-tab-trigger].is-active');
      handle = (activePill?.getAttribute('data-blog-handle') || '').trim();
      if (!handle && this.dataset.variant === 'all-blogs') {
        handle = new URLSearchParams(window.location.search).get('category') || '';
      }
    }

    try {
      sessionStorage.setItem('jp-all-blogs-category', handle);
    } catch (e) {}
  }

  #initArticleLinkTracking() {
    this.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || !this.contains(link)) return;

      const panel = link.closest('[data-tab-panel]');
      if (!panel) return;

      this.#rememberActiveCategoryTab(this.#getCategoryHandleForPanel(panel));
    });
  }

  #syncCategoryQuery(pill) {
    if (this.dataset.variant !== 'all-blogs') return;

    const url = new URL(window.location.href);
    const blogHandle = (pill.getAttribute('data-blog-handle') || '').trim();

    if (blogHandle) {
      url.searchParams.set('category', blogHandle);
    } else {
      url.searchParams.delete('category');
    }

    const next = `${url.pathname}${url.search}${url.hash}`;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (next === current) return;

    history.pushState({ blogCategoryTab: blogHandle || 'all' }, '', next);
  }

  #initCategoryQueryHistory() {
    if (this.dataset.variant !== 'all-blogs') return;

    window.addEventListener('popstate', () => {
      const tab = this.#getInitialTab();
      if (tab) this.#showTab(tab);
      this.#rememberActiveCategoryTab();
    });
  }

  #showTab(filter) {
    for (const pill of this.pills) {
      const isActive = pill.getAttribute('data-filter') === filter;
      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    for (const panel of this.panels) {
      const isActive = panel.getAttribute('data-tab') === filter;
      panel.classList.toggle('is-active', isActive);
    }

    this.#refreshVirtualDocumentHeight();
  }

  #revealMoreArticles(button) {
    const panel = button.closest('[data-tab-panel]');
    if (!panel) return;

    const list = panel.querySelector('[data-blog-list]');
    if (!list) return;

    const batchSize = Number(button.dataset.batchSize || 3);
    const hiddenCards = list.querySelectorAll('.blog-featured-category-grid__list-card--hidden');

    for (let i = 0; i < batchSize && i < hiddenCards.length; i++) {
      hiddenCards[i].classList.remove('blog-featured-category-grid__list-card--hidden');
    }

    if (!list.querySelector('.blog-featured-category-grid__list-card--hidden')) {
      button.remove();
    }

    this.#refreshVirtualDocumentHeight();
  }

  #initScrollTracking() {
    if (this.dataset.variant !== 'all-blogs') return;

    this.scrollThresholds = [25, 50, 75, 100];
    this.currentScrollBucket = -1;
    this.scrollDepthDwellTimer = null;
    this.scrollDepthDwellDuration = 2000;
    this.virtualDocumentHeight = this.#getVirtualDocumentHeight();

    window.addEventListener('scroll', () => {
      this.#handleScrollDepthProgress();
    }, { passive: true });
    window.addEventListener('resize', () => {
      this.#refreshVirtualDocumentHeight();
      this.#handleScrollDepthProgress();
    });

    this.#handleScrollDepthProgress();
  }

  #getCurrentScrollBucket() {
    const scrollable = this.virtualDocumentHeight - window.innerHeight;
    if (scrollable <= 0) return 0;

    const currentScroll = Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
    const scrolledPercent = Math.min(100, Math.max(0, Math.round((currentScroll / scrollable) * 100)));
    return this.#resolveScrollBucket(scrolledPercent);
  }

  #handleScrollDepthProgress() {
    if (this.dataset.variant !== 'all-blogs') return;

    const bucket = this.#getCurrentScrollBucket();
    if (bucket === this.currentScrollBucket) return;

    this.currentScrollBucket = bucket;

    if (this.scrollDepthDwellTimer) {
      clearTimeout(this.scrollDepthDwellTimer);
      this.scrollDepthDwellTimer = null;
    }

    if (bucket === 0) return;

    this.scrollDepthDwellTimer = setTimeout(() => {
      if (this.#getCurrentScrollBucket() !== bucket) return;

      this.#pushDataLayerEvent('scroll_depth', {
        source: 'blog',
        page_percent: bucket,
        page_location: window.location.href
      });
    }, this.scrollDepthDwellDuration);
  }

  #resolveScrollBucket(percent) {
    let bucket = 0;
    for (const threshold of this.scrollThresholds || []) {
      if (percent >= threshold) bucket = threshold;
    }
    return bucket;
  }

  #refreshVirtualDocumentHeight() {
    if (this.dataset.variant !== 'all-blogs') return;
    this.virtualDocumentHeight = this.#getVirtualDocumentHeight();
    this.#handleScrollDepthProgress();
  }

  #getVirtualDocumentHeight() {
    const currentDocHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );

    const activePanel = this.querySelector('[data-tab-panel].is-active') || this.querySelector('[data-tab-panel]');
    if (!activePanel) return currentDocHeight;

    const activeList = activePanel.querySelector('[data-blog-list]');
    if (!activeList) return currentDocHeight;

    const hiddenCards = activeList.querySelectorAll('.blog-featured-category-grid__list-card--hidden');
    if (!hiddenCards.length) return currentDocHeight;

    const visibleListHeight = activeList.getBoundingClientRect().height;
    const clonedList = activeList.cloneNode(true);
    clonedList.querySelectorAll('.blog-featured-category-grid__list-card--hidden').forEach((card) => {
      card.classList.remove('blog-featured-category-grid__list-card--hidden');
    });

    clonedList.style.position = 'absolute';
    clonedList.style.left = '-99999px';
    clonedList.style.top = '0';
    clonedList.style.visibility = 'hidden';
    clonedList.style.pointerEvents = 'none';
    clonedList.style.width = `${activeList.getBoundingClientRect().width}px`;
    document.body.appendChild(clonedList);
    const fullListHeight = clonedList.getBoundingClientRect().height;
    clonedList.remove();

    const extraHeight = Math.max(0, Math.round(fullListHeight - visibleListHeight));
    return currentDocHeight + extraHeight;
  }

  #pushDataLayerEvent(eventName, eventData) {
    window.dataLayer = window.dataLayer || [];
    const payload = {
      event: eventName,
      ...eventData
    };
    window.dataLayer.push(payload);
    this.#eventConsole(eventName, payload);
  }

  #eventConsole(eventName, eventData) {
    const css1 = 'background: red; color: #fff; font-size: normal; border-radius: 3px 0 0 3px; padding: 3px 4px;';
    const css2 = 'background-color: blue; color: #fff; font-size: normal; border-radius: 0 3px 3px 0; padding: 3px 4px;';
    console.log('%cGTM DataLayer Event:%c' + eventName, css1, css2, eventData);
  }
}

if (!customElements.get('blog-category-featured-section')) {
  customElements.define('blog-category-featured-section', BlogCategoryFeaturedSection);
}
  } catch(e) { console.error(e); }
})();

})();
